import React from 'react';

import { TooltipWrapper } from '@asteria/component-core/tooltip';
import { Text, Title } from '@asteria/component-core/typography';

import { Translation } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

const AuthStepper = ({ steps, currentStep, onStepClick, className }) => {
	const currentStepIndex = steps.findIndex((step) => step.id === currentStep);

	return (
		<div
			className={cn('flex flex-col items-center w-full gap-4', className)}
		>
			<div className="flex items-center justify-between w-full max-w-md gap-1 rounded-full overflow-hidden">
				{steps.map((step, index) => {
					const isPreviousStep = index < currentStepIndex;
					const isCurrentStep = index === currentStepIndex;
					const isNextStep = index === currentStepIndex + 1;

					return (
						<TooltipWrapper
							key={step.id}
							tooltip={
								<Translation
									translationKey={`auth.stepper.step-${
										index + 1
									}`}
									defaultText={
										'Step – {{step-' + (index + 1) + '}}'
									}
									Component={Text}
								/>
							}
						>
							<button
								type="button"
								onClick={() => onStepClick?.(step.id)}
								className={cn('h-1 flex-1 transition-colors', {
									'bg-[#D76C63] hover:bg-[#c45c54] cursor-pointer':
										isPreviousStep || isCurrentStep,
									'bg-[#F0F0ED] hover:bg-[#e5e5e2] cursor-pointer':
										isNextStep,
									'bg-[#F0F0ED] cursor-not-allowed':
										index > currentStepIndex + 1,
								})}
							/>
						</TooltipWrapper>
					);
				})}
			</div>
			<div className="text-left w-full mt-4">
				<Translation
					translationKey={steps[currentStepIndex]?.label}
					defaultText="Step"
					Component={Title}
					size="xxs"
				/>
			</div>
		</div>
	);
};

AuthStepper.displayName = 'AuthStepper';

export default AuthStepper;
